import { SmartImage } from '@/shared/ui/SmartImage';
import type { Episode } from '@/shared/types';
import { Play } from 'lucide-react';

export function EpisodeRow({ episodes }: { episodes: Episode[] }) {
  return (
    <section className="mt-8 px-4">
      <h3 className="font-serif italic text-lg text-white mb-3">Episodes · S1</h3>
      <ul className="space-y-3">
        {episodes.map((ep) => (
          <li key={ep.id} className="flex gap-3 active:scale-[0.98] transition-transform">
            <div className="relative w-32 rounded-lg overflow-hidden bg-black/30 flex-shrink-0">
              <SmartImage fill aspect="16/9" src={ep.thumb} alt={ep.title} sizes="128px" />
              <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                <Play className="w-5 h-5 text-white fill-current" />
              </div>
            </div>
            <div className="flex-1">
              <div className="text-sm text-white">
                {ep.episodeNo}. {ep.title}
              </div>
              <div className="text-[10px] text-white/40 uppercase tracking-wider mt-1">{ep.durationMin}m</div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
